/**
 * @generated SignedSource<<b729be0e774354aee4d40434d6a30eb1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ActiveRecords = "ACTIVE" | "BOTH" | "INACTIVE" | "%future added value";
export type StudentTargetFocusClassesQuery$variables = {
  isActive: ActiveRecords;
};
export type StudentTargetFocusClassesQuery$data = {
  readonly studentTargetFocusClasses: ReadonlyArray<{
    readonly classId: string;
    readonly id: string;
    readonly isActive: boolean;
    readonly targetId: string;
  }>;
};
export type StudentTargetFocusClassesQuery = {
  response: StudentTargetFocusClassesQuery$data;
  variables: StudentTargetFocusClassesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isActive"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "isActive",
        "variableName": "isActive"
      }
    ],
    "concreteType": "StudentTargetFocusClassNode",
    "kind": "LinkedField",
    "name": "studentTargetFocusClasses",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isActive",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "targetId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "classId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StudentTargetFocusClassesQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StudentTargetFocusClassesQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "88c331919b2ce9c837fa5f6cedde9e64",
    "id": null,
    "metadata": {},
    "name": "StudentTargetFocusClassesQuery",
    "operationKind": "query",
    "text": "query StudentTargetFocusClassesQuery(\n  $isActive: ActiveRecords!\n) {\n  studentTargetFocusClasses(isActive: $isActive) {\n    id\n    isActive\n    targetId\n    classId\n  }\n}\n"
  }
};
})();

(node as any).hash = "5bdb80cf2df1d629e6eabe89fc5cdf5d";

export default node;
